import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, useField } from 'react-final-form';
import { Col, Datepicker, Row, Select } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { required } from '../../../../../../utils/utils';

const propTypes = {
  fieldName: PropTypes.string,
  fieldData: PropTypes.object,
};

function DateFieldType({ fieldName, fieldData }) {
  // Initialize state based on existing field data or empty for new fields
  const [defaultValue, setDefaultValue] = useState(
    fieldData.defaultValue
      ? fieldData.defaultValue === 'today'
        ? 'today'
        : 'customDate'
      : '', // Empty for new date fields
  );
  const {
    input: { onChange },
  } = useField(`${fieldName}.defaultValue`);

  const options = [
    {
      label: (
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateField.defaultValue.type.empty"
          defaultMessage="Select type"
        />
      ),
      value: '',
    },
    {
      label: (
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateField.defaultValue.type.today"
          defaultMessage="Today"
        />
      ),
      value: 'today',
    },
    {
      label: (
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateField.defaultValue.type.customDate"
          defaultMessage="Custom date"
        />
      ),
      value: 'customDate',
    },
  ];

  const changeDefaultValueType = (e) => {
    const selectedType = e.target.value;

    if (selectedType === 'today') {
      onChange('today');
      setDefaultValue('today');
    } else if (selectedType === 'customDate') {
      onChange(''); // Empty until user selects a date
      setDefaultValue('customDate');
    } else {
      onChange(''); // Empty when no selection
      setDefaultValue('');
    }
  };

  useEffect(() => {
    if (!fieldData.defaultValue) {
      // New date field - no selection
      setDefaultValue('');
      onChange('');
    } else if (fieldData.defaultValue === 'today') {
      // Saved as "today"
      setDefaultValue('today');
      onChange('today');
    } else {
      // Saved as custom date
      setDefaultValue('customDate');
      onChange(fieldData.defaultValue);
    }
  }, []);

  return (
    <Row>
      <Col xs={6}>
        <Select
          id={`inventory-templates-form-generator-${fieldData.type}-field-${fieldName}-defaultValue-type`}
          label={
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateField.defaultValue.type"
              defaultMessage="Default value type"
            />
          }
          onChange={(e) => changeDefaultValueType(e)}
          value={defaultValue}
          dataOptions={options}
        />
      </Col>
      {defaultValue === 'customDate' && (
        <Col xs={6}>
          <Field
            id={`inventory-templates-form-generator-${fieldData.type}-field-${fieldName}.defaultValue`}
            component={Datepicker}
            fullWidth
            name={`${fieldName}.defaultValue`}
            label={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templateField.defaultValue.label"
                defaultMessage="Default value"
              />
            }
            dateFormat="YYYY/MM/DD"
            backendDateStandard="YYYY/MM/DD"
            allowNull
            required
            validate={required}
          />
        </Col>
      )}
    </Row>
  );
}

DateFieldType.propTypes = propTypes;

export default DateFieldType;
